import * as React from 'react';

import { useBreakpointValue } from '@notino/react-styleguide';

import { useApolloClientHeaders } from '@hooks/useApolloClientHeaders';

import { useSkinAnalyzerBrandData } from '../hooks/useSkinAnalyzerBrandData';
import { Image } from '../styled';

export const BrandImage = () => {
  const brand = useSkinAnalyzerBrandData();
  const { shopId } = useApolloClientHeaders();

  const isDesktop = useBreakpointValue({ lg: true }, { ssrValue: true });

  const imageUrl = isDesktop
    ? brand?.imageByShopId?.[shopId]
    : brand?.imageByShopId?.[shopId].replace('desktop', 'web');

  return <Image src={imageUrl} alt="skin analyser image" />;
};
